import classNames from "classnames";

import styles from "./SegmentedControl.module.css";

type Props = {
  className?: string;
  tabs: string[];
  currentIndex: number;
  onPress: (index: number) => void;
};

export default function SegmentedControl(props: Props) {
  return (
    <div className={classNames(styles.container, props.className)}>
      {props.tabs.map((tab, index) => {
        return (
          <button
            key={index}
            className={classNames(
              styles.segmentChild,
              props.currentIndex === index && styles.isClicked,
            )}
            onClick={() => props.onPress(index)}
          >
            <div
              className={classNames(
                styles.segmentText,
                props.currentIndex === index && styles.isClickedText,
              )}
            >
              {tab}
            </div>
          </button>
        );
      })}
    </div>
  );
}
